exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".alternate-mobile-number-container{margin-top:2rem;gap:1rem}.alternate-mobile-number-container .section-msg{text-align:center}\n", ""]);

